import React from 'react'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

function QuantitySelector({ availableQuantity, classes, quantity, setQuantity }) {
	const setNewQty = (variation) => {
		let newQuantity = Number(quantity) + Number(variation)
		setQty(newQuantity)
	}
	const setQty = (value) => {
		if (value <= 0) {
			value = 1
		}
		if (!!availableQuantity && value > availableQuantity) {
			value = Number(availableQuantity)
		}
		setQuantity(value)
	}
	return (<div className={classes.quantitySelector}>
		<input type="number" min="1" max="9999" step="1" value={Number(quantity)} onChange={(e) => setQty(Number(e.target.value))} />
		<div className="quantity-button quantity-up" onClick={() => setNewQty(1)}>+</div>
		<div className="quantity-button quantity-down" onClick={() => setNewQty(-1)}>-</div>
	</div>)
}

export default withStyles(style)(QuantitySelector)
